import Header from "../Components/Header/Header";
import FilterSkills from "../Components/Skills/FilterSkills";
import { useAuthContext } from "../context/AuthContext";
import Loading from "../Components/Hooks/Loading";
import "./Activities.css";
import Footer from "../Components/Footer/Footer";

const Activities = () =>{
    const { user, isLoading, setUser } = useAuthContext();
    if(isLoading)
        return <Loading/>
    else{
        return(
            <div className="activities">
                <div className="container">
                    <Header title ="Practice" />
                    <div className="content-wrap bg-gradient-light">
                        <div className="content-wrap-inner">
                        <div className="description fade-in-down delay-3">
                            <h2 className="title mt---0 mb---20">Practice Skills</h2>
                            <h4 className="sub-title mt---0 mb---10">Take a moment to breathe & reset.</h4>
                            <p className="text">The activities below offer the opportunity to practice mindfulness, grounding, and
communication skills.</p>
                        </div>
                        <FilterSkills headTitle=""/>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        );
    }
}
export default Activities;